// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "SelfServAdviceSet" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { SelfServQuestionResponseGenShape } from "./self-serv-question-response.gen";

export const SelfServAdviceSetGenShape = z.strictObject({
  name: z.string(),
  description: z.string(),
  slug: z.string(),
  snippetIds: z.array(z.string()),
  relatedAdvice: z.array(SelfServQuestionResponseGenShape).optional(),
  tagId: z.string().optional(),
  keywords: z.string().optional(),
  quickExit: z.boolean(),
  errors: z.array(z.string()).optional(),
  lastEdited: z.string().optional(),
  id: z.string(),
});
